class GiftWrappingComponent extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("m-cart-drawer");
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping === "true"; // asegúrate de convertir a booleano
    this.cartItemsSize = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.itemsInCart = parseInt(this.getAttribute("items-in-cart"));
    this.loadingIcon = this.querySelector(".m-gift-wrapping--loading");
    this.cart = document.querySelector("m-cart-drawer");

    const checkbox = this.querySelector('[name="attributes[gift-wrapping]"]');
    this.checkbox = checkbox;

    if (checkbox) {
      // Asegura que el checkbox refleje el estado real
      checkbox.checked = this.giftWrapping;

      checkbox.addEventListener("change", (e) => {
        if (e.target.checked) {
          this.setGiftWrapping();
        } else {
          this.removeGiftWrapping();
        }
      });
    }

    if (!this.cartDrawer) return;

    // Auto eliminar si no hay productos pero sí empaque
    if (this.itemsInCart === 0 && this.giftWrapsInCart > 0) {
      this.removeGiftWrapping();
    }
  }

  setGiftWrapping(quantity = null) {
    this.loadingIcon.classList.add("show");
    const inputQuantity = quantity ?? parseInt(document.querySelector("m-gift-wrapping-input input")?.value || 1);

    const data = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json"
      }),
      body: JSON.stringify({
        updates: { [this.giftWrapId]: inputQuantity },
        attributes: { "gift-wrapping": true }
      })
    };

    this.updateCart(data, true);
  }

  removeGiftWrapping() {
    this.loadingIcon.classList.add("show");

    const data = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json"
      }),
      body: JSON.stringify({
        updates: { [this.giftWrapId]: 0 },
        attributes: { "gift-wrapping": false, "gift-note": "" }
      })
    };

    this.updateCart(data, false);
  }

  updateCart(data, isWrappingAdded) {
    return fetch(`${MinimogSettings.routes.cart_update_url}`, data)
      .then((res) => res.json())
      .then((res) => {
        this.loadingIcon.classList.remove("show");

        // Actualizar visual del checkbox
        if (this.checkbox) {
          this.checkbox.checked = isWrappingAdded;
        }

        if (document.body.classList.contains("template-cart")) {
          window.location.href = MinimogSettings.routes.cart;
        } else if (this.cartDrawer) {
          this.cart.onCartDrawerUpdate();
          this.cartDrawer.classList.toggle("m-cart--empty", res.item_count === 0);
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, res);
        }
      })
      .catch(() => {});
  }
}

customElements.define("m-gift-wrapping-component", GiftWrappingComponent);

class GiftNoteComponent extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "change",
      debounce((e) => {
        const data = {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json"
          }),
          body: JSON.stringify({
            attributes: { "gift-note": e.target.value }
          })
        };
        fetch(`${MinimogSettings.routes.cart_update_url}`, data);
      }, 300)
    );
  }
}

customElements.define("m-gift-note-component", GiftNoteComponent);

class GiftWrappingQuantityInput extends MQuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();
    this.giftWrapping = document.querySelector("m-gift-wrapping-component");
    this.cartItemsSize = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.itemsInCart = parseInt(this.getAttribute("items-in-cart"));

    this.input.addEventListener("change", () => {
      let newValue = parseInt(this.input.value);
      if (isNaN(newValue) || newValue < 1) newValue = 1;
      if (newValue > this.itemsInCart) newValue = this.itemsInCart;

      this.input.value = newValue;

      if (this.giftWrapping) {
        this.giftWrapping.setGiftWrapping(newValue);
      }
    });
  }
}

customElements.define("m-gift-wrapping-input", GiftWrappingQuantityInput);


